import { API_URL } from '../../util/networkEndpoints';
import { LocalizedText } from "../../components/LocalizedText";
import './Register.css';
import './AuthNinja.css';
import logo from '../../assets/pknin-logo.png';
import { isMobileGameDevice } from '../../hooks/useMobileGameViewport';
import { MobileAuthEffects } from './MobileAuthEffects';
import { MobileRegisterArt } from './MobileRegisterArt';
import * as React from 'react';
import { postData } from '../../util/fetch';
import { useAppDispatch } from '../../hooks';
import { LoadState, setId, setLoadState } from '../../slices/accountSlice';
import { ServerSelect } from './ServerSelect';

interface Props {
  onClose: () => void;
  onLogin?: () => void;
}

export const Register: React.FC<Props> = ({ onClose, onLogin }) => {
  const [mobile] = React.useState(isMobileGameDevice);
  const dispatch = useAppDispatch();
  const [username, setUsername] = React.useState('');
  const [password, setPassword] = React.useState('');
  const [confirmPassword, setConfirmPassword] = React.useState('');
  // const [key, setKey] = React.useState('');
  const [response, setResponse] = React.useState('Password must be at least 8 characters long.');
  const [busy, setBusy] = React.useState(false);
  const [registered, setRegistered] = React.useState(false);
  const [session, setSession] = React.useState<{ jwt: string; servers: number[]; valid: number[] } | null>(null);
  const pending = React.useRef(false), mounted = React.useRef(true);
  React.useEffect(() => () => { mounted.current = false; }, []);

  async function onSubmit() {
    if (pending.current) return;
    pending.current = true; setBusy(true);
    try {
      if (!registered) {
        const result = await postData(`${API_URL}/register`, { username, password });
        if (!mounted.current) return;
        if (result.error) { setResponse(result.error); return; }
        setRegistered(true);
      }
      const login = await postData(`${API_URL}/login`, { username, password });
      if (!mounted.current) return;
      if (login.error) { setResponse(`สมัครสมาชิกสำเร็จแล้ว แต่เข้าสู่ระบบไม่สำเร็จ: ${login.error}`); return; }
      if (!login.jwt || !Array.isArray(login.servers) || !login.servers.length || !Array.isArray(login.valid)) {
        setResponse('สมัครสมาชิกสำเร็จแล้ว แต่โหลดรายชื่อเซิร์ฟเวอร์ไม่สำเร็จ กรุณาลองอีกครั้ง'); return;
      }
      dispatch(setId(login.id));
      dispatch(setLoadState(LoadState.LOADING));
      setPassword(''); setConfirmPassword('');
      setSession({ jwt: login.jwt, servers: login.servers, valid: login.valid });
    } catch {
      if (mounted.current) setResponse('เชื่อมต่อไม่สำเร็จ กรุณาลองอีกครั้ง');
    } finally {
      pending.current = false;
      if (mounted.current) setBusy(false);
    }
  }

  if (session) return <ServerSelect jwt={session.jwt} servers={session.servers} valid={session.valid} startAt={mobile?'servers':undefined} onClose={onClose} />;
  if(mobile) return <MobileRegisterArt username={username} password={password} confirm={confirmPassword} busy={busy} registered={registered} message={response} onUsername={setUsername} onPassword={setPassword} onConfirm={setConfirmPassword} onSubmit={onSubmit} onLogin={onLogin||onClose}/>;

  return (
    <div className={`register-container ninja-auth${mobile ? ' mobile-game-auth' : ''}`}>
      <div className="blur" />
      {mobile && <MobileAuthEffects />}
      <div className="register-modal" role="dialog" aria-modal="true" aria-labelledby="ninja-register-title">
        <img className="ninja-auth-logo" src={logo} alt="PkNiN" />
        <span className="ninja-auth-seal" aria-hidden="true">忍</span>
        <button id="register__close" aria-label="ปิดหน้าต่างสมัครสมาชิก" onClick={onClose}>
          X
        </button>

        <h2 id="ninja-register-title"><LocalizedText text={"Register"} /></h2>
        <p className="ninja-auth-intro">สร้างบัญชี แล้วเริ่มต้นเส้นทางนินจาบทใหม่</p>

        <div id="register__body">
          <div>
            <label htmlFor="username"><LocalizedText text={"Username:"} /></label>
            <input type="text" id="username" disabled={busy || registered} onChange={(e) => setUsername(e.currentTarget.value)} />
          </div>

          <div>
            <label htmlFor="password"><LocalizedText text={"Password:"} /></label>
            <input type="password" id="password" disabled={busy || registered} onChange={(e) => setPassword(e.currentTarget.value)} />
          </div>

          <div>
            <label htmlFor="confirmPassword"><LocalizedText text={"Confirm Password:"} /></label>
            <input type="password" id="confirmPassword" disabled={busy || registered} onChange={(e) => setConfirmPassword(e.currentTarget.value)} />
          </div>

          {/* <div>
            <label htmlFor="key">Key:</label>
            <input type="text" id="key" onChange={(e) => setKey(e.currentTarget.value)} />
          </div> */}
        </div>

        <div id="register__response"><LocalizedText text={response} /></div>

        <div id="register__submit">
          <button onClick={onSubmit} disabled={busy || username === '' || password.length < 8 || password !== confirmPassword}><LocalizedText text={busy ? 'กำลังดำเนินการ…' : registered ? 'ลองเข้าสู่ระบบอีกครั้ง' : 'Submit'} /></button>
        </div>
        {onLogin && <button type="button" className="ninja-auth-switch" onClick={onLogin} disabled={busy}>มีบัญชีแล้ว · เข้าสู่ระบบ</button>}
        <p className="ninja-auth-footnote">PkNiN · พร้อมออกผจญภัยไปด้วยกัน</p>
      </div>
    </div>
  );
};
